// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b2b-lib-dotsLoader span{opacity:0;animation:b2b-lib-dots 0.75s steps(5, end) infinite;color:#cc000a;font-size:calc(100% + 8px)}span:nth-child(1){animation-delay:.25s}span:nth-child(2){animation-delay:.5s}span:nth-child(3){animation-delay:.75s}@keyframes b2b-lib-dots{0%{opacity:0}50%{opacity:1}100%{opacity:0}}\n", ""]);
// Exports
exports.locals = {
	"dotsLoader": "b2b-lib-dotsLoader",
	"dots": "b2b-lib-dots"
};
module.exports = exports;
